import React from 'react';
import moment from 'moment';
import './SessionHeader.scss';

interface SessionHeaderProps {
  sessionPeriod?: {
    start: string;
    end: string;
  };
}

const SessionHeader: React.FC<SessionHeaderProps> = ({ sessionPeriod }) => {
  return (
    <>
      {/* Logo */}
      <div className="sb-logo">
        <img src="/logos/Recurso 53MEDIOPUNTO.png" alt="Medio Punto" />
      </div>

      {/* Header */}
      <div className="sb-header">
        <h3 className="sb-title">Resumen de Ventas</h3>
        {sessionPeriod ? (
          <div className="sb-period">
            {moment(sessionPeriod.start).format('dddd, D [de] MMMM [de] YYYY [a las] HH:mm [hrs]')}
            <br />
            {sessionPeriod.end && `hasta el ${moment(sessionPeriod.end).format('D [de] MMMM [de] YYYY [a las] HH:mm [hrs]')}`}
          </div>
        ) : (
          <div className="sb-period">Sesión Actual</div>
        )}
      </div>
    </>
  );
};

export default SessionHeader;
